import { render, staticRenderFns } from "./TabPodcasts.vue?vue&type=template&id=63f711be&"
import script from "./TabPodcasts.vue?vue&type=script&lang=js&"
export * from "./TabPodcasts.vue?vue&type=script&lang=js&"
import style0 from "./TabPodcasts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabPodcasts.vue"
export default component.exports